import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  RedirectCommand,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from "@angular/router";
import { inject, PLATFORM_ID } from "@angular/core";
import { isPlatformServer } from "@angular/common";
import { SearchService } from "src/app/services/search.service";
import { from, of } from "rxjs";

export async function bookNameHtmlRedirectGuard(
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
): Promise<RedirectCommand> {
  const searchService = inject(SearchService);
  const router = inject(Router);
  const platformId = inject(PLATFORM_ID);
  const path = route.params["path"];

  let response: any = null;

  // Set 301 status code on server-side
  if (isPlatformServer(platformId)) {
    try {
      response = inject("RESPONSE" as any) as any;
      if (response && typeof response.status === "function") {
        response.status(301);
      }
    } catch (e) {
      console.warn("Could not set 301 status:", e);
    }
  }

  let pathSegments: string[] = [];

  if (path.endsWith(".html")) {
    const title =
      path.split("/").pop()?.replace(".html", "").replace(/_/g, " ") || "";

    if (title == "gam-20") {
      pathSegments = ["book", "9783986120665"];
    } else {
      // console.log(title);
      const isbn = await searchService.getISBNbyTitle(title);

      if (isbn) {
        pathSegments = ["book", isbn];
      } else {
        pathSegments = ["search"];
      }
    }
  } else {
    pathSegments = ["search"];
  }

  // Extract language prefix from current URL (e.g., 'en' or 'de')
  const urlSegments = state.url.split("/").filter(Boolean);
  const langSegment = urlSegments[0]; // First segment is the language

  // Include language prefix to create absolute path like /en/book/isbn
  const navigationPath = [langSegment, ...pathSegments];
  const urlTree = router.createUrlTree(navigationPath);

  // Set Location header for proper 301 redirect
  if (response && typeof response.setHeader === "function") {
    const locationUrl = urlTree.toString();
    response.setHeader("Location", locationUrl);
    // console.log("301 Redirect Location:", locationUrl);
  }

  return new RedirectCommand(urlTree);
}
